<template>
  <div class="container z-flex">
    <leftAsideCom ref="leftAsideCom"></leftAsideCom>
    <div class="main-con">
      <div class="main-box" ref="mainBox">
        <div class="upload-box z-flex z-flex-center">
          <!-- <el-button type="primary" class="btn-reupload" size="small" v-if="fileList[0]" @click="reupload">点击图片重新上传</el-button> -->
          <div class="z-flex z-flex-between" style="width: 100%;height: 100%;">
            <div class="main-50">
              <el-upload
                class="upload upload-2"
                drag
                action=""
                :accept="upAccept"
                :auto-upload="true"
                :before-upload="handleBeforeUpload"
                :http-request="(opt) => {
                  this.handleHttpRequestOss(opt, '2')
                }"
                :show-file-list="false"
                v-if="activeTemp.id"
              >
                <div class="img-wrap z-flex z-flex-center" v-if="fileList2[0]">
                  <img class="img" :src="fileList2[0]" />
                  <div class="upload-tips z-flex z-flex-center"><i class="el-icon-upload2"></i>点击图片重新上传</div>
                </div>
                <div
                  class="upload-action-con z-flex z-flex-col z-flex-center"
                  v-else
                >
                  <i class="el-icon-upload el-icon-picture-outline"></i>
                  <div class="el-upload__text">
                    <p>点击上传背景模版</p>
                    <p>支持5MB以内的JPG、PNG</p>
                  </div>
                </div>
              </el-upload>
            </div>
            <div class="main-50">
              <el-upload
                class="upload upload-1"
                ref="uploadBox"
                drag
                action=""
                :accept="upAccept"
                :auto-upload="true"
                :before-upload="handleBeforeUpload"
                :http-request="(opt) => {
                  this.handleHttpRequestOss(opt, '1')
                }"
                :show-file-list="false"
              >
                <div class="img-wrap z-flex z-flex-center" v-if="fileList[0]">
                  <img class="img" :src="fileList[0]" />
                  <div class="upload-tips z-flex z-flex-center"><i class="el-icon-upload2"></i>点击图片重新上传</div>
                </div>
                <div
                  class="upload-action-con z-flex z-flex-col z-flex-center"
                  v-else
                >
                  <i class="el-icon-upload el-icon-user"></i>
                  <div class="el-upload__text">
                    <p>点击上传正面头像照片</p>
                    <p>支持5MB以内的JPG、PNG</p>
                  </div>
                </div>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="z-flex z-flex-center">
          <el-button type="primary" class="btn-creat" @click="make">创作</el-button>
        </div>
      </div>
      <!-- loading -->
      <loadingCom ref="loadingCom"></loadingCom>
    </div>
    <div class="aside-r aside-r-c">
      <div class="aside-r-c-hd z-flex z-flex-between">
        <div :class="['item',showRcon==='param'?'active':'']" @click="showRcon='param'">参数配置</div>
        <div :class="['item',showRcon==='history'?'active':'']" @click="showRcon='history'">历史记录</div>
      </div>
      <div class="aside-r-con-wrap" v-if="showRcon==='param'">
        <div class="aside-r-con">
          <div class="box-hd z-flex">模版</div>
          <div class="bd-tab z-flex z-flex-between">
            <div :class="['tab-item',activeTempType==='men'?'active':'']" @click="changeTempType('men')">男士</div>
            <div :class="['tab-item',activeTempType==='women'?'active':'']" @click="changeTempType('women')">女士</div>
            <div :class="['tab-item',activeTempType==='children'?'active':'']" @click="changeTempType('children')">儿童</div>
          </div>
          <div class="bd model-q">
            <div class="z-flex">
              <div 
                :class="['item',activeTemp.id===item.id?'active':'']"  
                v-for="(item, index) in tempList2" 
                :key="index" 
                :title="item.title"
                @click="selTemp(item)"
              >
                <el-image class="img" fit="cover" lazy :src="item.img"></el-image>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="aside-r-con-wrap" v-show="showRcon==='history'">
        <historyCom ref="historyCom" @clickHitoryItem="clickHitoryItem"></historyCom>
      </div>
    </div>
  </div>
</template>

<script>
import historyCom from "@/components/historyCom.vue"
export default {
  components: {
	  historyCom
  },
  data() {
    return {
      showRcon:'param',
      input:'',
      sendLoading:false,
      img:'',
      imageURL:'',
      faceImageURL:'',
      file_id: '',
      file_id2: '',
      radioType:null,
      radioTimes:null,
      radioSel:null,
      templateId:null,
      upAccept: "image/jpeg,image/gif,image/png",
      fileList: [],
      fileList2: [],
      activeTemp:{//模板
        id: 1,
        img: '',
        title: '',
      },
      tempList:[],
      tempList2:[],
      activeTempType:'men',
    };
  },
  watch:{
    
  },
  created() {
    if(typeof(this.$route.query.imgUrl) != "undefined"){
      this.showImage(this.$route.query.imgUrl);
    }
  },
  mounted() {
    this.$refs.historyCom.getHistoryList('face-swap');
    this.$axios.api.request(
            {
              url: "/api.php/Index/getFaceswapTemplates?type=1",
              method: "GET",
            },
            (res) => {
              if (res.errno == 0) {
                for (var i=0; i<res.data.list.length; i++) {
                  this.tempList.push(res.data.list[i]);
                }
                this.changeTempType(this.activeTempType);
              }else{
                this.$message.error(res.message);
              }
            }
    );
  },
  methods: {
    // 切换图片
    showImage(img){
      this.img = img;
      this.imageURL = this.img;
      this.fileList = [this.img];
    },
    /**
     * 立即生成
     */
    make(){
      if (!this.$myFun.isLogin()) {
        return this.$parent.showLogin();
      }
      if (this.imageURL == '') {
        return this.$message.error("请先上传图片");
      }
      // this.$refs.loadingCom.showLoading = true;
      // this.sendLoading = true; //按钮loading
      this.$axios.api.request(
        {
          url: "/api.php/chat/faceSwap",
          method: "POST",
          data: {
            token: this.$cookies.get("token"),
            template_id: this.templateId,
            source_url: this.imageURL,
            face_url: this.faceImageURL,
          },
        },
        (res) => {
          if (res.errno == 0) {
            this.$myFun.toUrl('/textToImg');
          }else{
            this.$message.error(res.message);
          }
        }
      );
    },
    /**
     * 上传之前的校验
     * @param file
     * @returns {boolean|boolean}
     */
    handleBeforeUpload(file) {
      this.upAccept = this.upAccept.toLowerCase();
      let isImage = this.upAccept.indexOf(file.type.toLowerCase()) >= 0;
      let isSize = file.size / 1024 / 1024 < 5;
      if (this.upAccept == "" || this.upAccept == "*") {
        isImage = true;
      }
      if (!isImage) {
        this.$message.error("请上传指定的图片格式[" + this.upAccept + "]!");
      } else if (!isSize) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isImage && isSize;
    },
    /**
     * 上传图片
     * @param opt
     */
    handleHttpRequestOss(opt, type) {
      var loading = null;
      if (type == '2') {
        loading = this.$loading({
          target:'.upload-2',
          background:'rgba(0,0,0,.6)',
        });
      }else{
        loading = this.$loading({
          target:'.upload-1',
          background:'rgba(0,0,0,.6)',
        });
      }
      // 生成本地预览url
      let URL = null;
      if (window.createObjectURL != undefined) {
        // basic
        URL = window.createObjectURL(opt.file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        URL = window.URL.createObjectURL(opt.file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        URL = window.webkitURL.createObjectURL(opt.file);
      }
      //获取图片信息
      this.$myFun.getImageInfo(URL, (res) => {
        //回调内容
        var cropsize = this.$myFun.cropImageSize(res.width, res.height, 1024, 1024);
        // console.log("图片信息------",res, cropsize)
      })
      // 读取图片内容，并计算 hash-256
      const reader = new FileReader();
      reader.onloadend = (e) => {
        var filecontent = e.target.result;
        var postdata = {
          filetype: opt.file.type,
          filename: opt.file.name,
          filesize: opt.file.size,
        };
        this.$axios.api.initImage(postdata, (res) => {
          if (res.errno == 0 && res.data.status.code == 10000) {
            if (res.data.data.img_status == 1) {
              var myHeaders = new Headers();
              myHeaders.append("Accept", "*/*");
              myHeaders.append("Host", "upload.api.seaart.me");
              myHeaders.append("Connection", "keep-alive");
              myHeaders.append("Content-Type", postdata.filetype);
              var requestOptions = {
                method: 'PUT',
                headers: myHeaders,
                body: filecontent,
                redirect: 'follow'
              };
              fetch(res.data.data.pre_sign, requestOptions)
                      .then(response => response.text())
                      .then((result) => {
                        // console.log('----------------', result);
                        this.$axios.api.request(
                                {
                                  url: "/api.php/upload/getFileUrl?file_id=" + res.data.data.file_id,
                                  method: "GET",
                                },
                                (res) => {
                                  if (res.errno == 0) {
                                    if (type == '2') {
                                      // 右侧上传
                                      this.fileList2 = [URL];
                                      this.faceImageURL = res.data.data.url;
                                      this.file_id2 = res.data.data.file_id;
                                    } else {
                                      this.fileList = [URL];
                                      this.imageURL = res.data.data.url;
                                      this.file_id = res.data.data.file_id;
                                    }
                                    loading.close();
                                  }else{
                                    this.$message.error(res.message);
                                  }
                                }
                        );
                      })
                      .catch(error => console.log('put error', error));
            } else if (res.data.data.img_status == 2) {
              if (type == '2') {
                // 右侧上传
                this.fileList2 = [URL];
                this.faceImageURL = URL;
                this.file_id2 = result.data.data.img_url;
              } else {
                this.fileList = [URL];
                this.imageURL = URL;
                this.file_id = result.data.data.img_url;
              }
              loading.close();
            }
          }else{
            this.$message.error(res.message);
            loading.close();
          }
        });
      }
      reader.readAsArrayBuffer(opt.file)
    },
    //阿里云直传
    uploadOss(file, callback){
      let fileName = file.name;
      this.$axios.api.aliossParams({name: fileName, md5: file.md5}, (resa) => {
        if (resa.code == 200) {
          //阿里云前端直传
          var patt = /^\/\//;
          resa.data.host = (patt.test(resa.data.host) ? 'https:' : '') + resa.data.host;
          var ossform = new FormData();
          ossform.append("name", fileName);
          ossform.append("key", resa.data.key);
          ossform.append("policy", resa.data.policy);
          ossform.append("OSSAccessKeyId", resa.data.OSSAccessKeyId);
          ossform.append("success_action_status", resa.data.success_action_status);
          ossform.append("signature", resa.data.signature);
          ossform.append("callback", resa.data.callback);
          ossform.append("host", resa.data.host);
          ossform.append("file", file, fileName);
          this.$axios.post(resa.data.host, ossform, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(res => {
            if (res.status == 200 || res.status == 203) {  //上传成功
              file.ossurl = resa.data.host + "/" + resa.data.key;
              callback(file);
              // this.$message.success("上传成功!")
            } else {
              this.$message.error("上传失败，请重新尝试!");
            }
          }).catch(error => {
            console.log("alioss错误: ", error);
          })
        }
      })
    },
    //点击历史记录
    clickHitoryItem(res){
      this.fileList = [res.img];
    },
    //重新上传
    reupload(){
      this.$refs.uploadBox.$refs["upload-inner"].handleClick();
    },
    //选择模板
    selTemp(item){
      this.activeTemp = item;
      this.templateId = '';
      this.faceImageURL = '';
      this.fileList2 = [];
      if(item.id > 0){
        if(item.template_id != ''){
          this.templateId = item.template_id;
        }else{
          this.fileList2 = [item.img];
          this.faceImageURL = item.template_image;
        }
      }
    },
    //切换模版分类
    changeTempType(type){
      this.activeTempType = type;
      this.tempList2 = [
        {
          id:-1,
          img:require('@/assets/images/facechanging.jpg'),
          title:'自定义',
        }
      ];
      for (let i in this.tempList) {
        if(this.activeTempType == this.tempList[i].class){
          this.tempList2.push(this.tempList[i]);
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.main-box{
  .main-50{
    width:calc(50% - 5px);
    height: 100%;
    .temp-preview-wrap{
      width: 100%;
      height: 100%;
      background: $colorBgLight;
      border-radius: 6px;
      .temp-preview-img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
.aside-r{
  .model-q{
    align-items: flex-start;
    .item{
      width: calc(25% - 10px);
      height:85px;
      position: relative;
      border: 2px solid $colorBgLight;
      box-sizing: border-box;
      margin: 0 10px 10px 0;
      cursor: pointer;
      border-radius: 6px;
      overflow: hidden;
      .img{
        width:100%;
        height:100%;
        border-radius: 0;
      }
      .title{
        width:100%;
        height:22px;
        line-height: 22px;
        font-size: 12px;
        color: #fff;
        text-align: center;
        @extend %textOverflow;
        padding: 0 5px;
        box-sizing: border-box;
        position: absolute;
        left: 0;
        bottom: 0;
        margin: 0;
        background: rgba(0,0,0,.5);
      }
      &.active {
        border-color: $colorMain;
      }
    }
  }
  .bd-tab{
    margin-bottom: 15px;
    .tab-item{
      flex: 1;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      border-bottom: $border;
      box-sizing: border-box;
      &.active{
        color: $colorMain;
        border-bottom: 1px solid $colorMain;
      }
      &:hover{
        color: $colorMain;
      }
    }
  }
}
</style>
